import parse from "html-react-parser";
import "./ProductInfo.css";
import ComboDetailInfo from "./comboDetailInfo";

// component thể hiện thông tin mô tả các ưu điểm sản phẩm
const ProductInfo = (props) => {
  return (
    <section className="productInfo ck-content">
      <h4 className="text-primary ms-3">Mô tả</h4>
      <div>
        <p className="text-muted fw-bold fs-5 ms-3">
          Thông tin chi tiết sản phẩm
        </p>

        {props.product.category !== "Combo" ? (
          <table className=" tableBorder m-auto text-center">
            <thead>
              <tr>
                <th>Sản phẩm</th>
                <th colSpan={props.product.detail.size.length}>
                  {props.product.name}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Size</td>
                {props.product.detail.size.map((sz, i) => (
                  <td key={i}>{sz}</td>
                ))}
              </tr>
              <tr>
                <td>Số miếng</td>
                {props.product.detail.numberOfPiece.map((quan, i) => (
                  <td key={i}>{quan}</td>
                ))}
              </tr>
              <tr>
                <td>Cân nặng</td>
                {props.product.detail.babyWeight.map((weight, i) => (
                  <td key={i}>{weight}</td>
                ))}
              </tr>

              {props.product.detail.material && (
                <tr>
                  <td>Thành phần</td>
                  <td colSpan={props.product.detail.size.length}>
                    {props.product.detail.material}
                  </td>
                </tr>
              )}

              {props.product.detail.packageMethod && (
                <tr>
                  <td>Quy cách đóng gói</td>
                  <td colSpan={props.product.detail.size.length}>
                    {props.product.detail.packageMethod}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <ComboDetailInfo />
        )}
      </div>

      {props.product.test.img5 && (
        <div className="mt-3">
          <p className="text-muted fw-bold fs-5 ms-3">Tiêu chuẩn kiểm định</p>
          <p className="ms-3">{props.product.test.testContent}</p>
          <div className="text-center">
            <img
              style={{ width: "100%", maxWidth: "600px" }}
              src={props.product.test.img5}
              alt={`test ${props.product.category}`}
            />
          </div>
        </div>
      )}

      <div className="mt-3" style={{ width: "95%" }}>
        <p className="text-muted fw-bold fs-5 ms-3">Ưu điểm của sản phẩm</p>
        <p className="ms-4" style={{ whiteSpace: "pre-wrap" }}>
          {parse(props.product.advantage)}
        </p>
      </div>
    </section>
  );
};
export default ProductInfo;
